import React from 'react';
import VideoTags from './VideoTags';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import VideoPlayer from './VideoPlayer';
import PropTypes from 'prop-types';
import MuxVideoPlayer from './MuxVideoPlayer';

const ClassVideoTrailer = ({ selectedVideo, errorMessage }) => {
	const navigate = useNavigate();

	return (
		<div className="common-container">
			<div className="common-main">
				<div className="common-headers">
					<h1>{selectedVideo?.title}</h1>
					<div>
						{selectedVideo?.instructor && (
							<div className="video-instructor">
								<PersonOutlineIcon style={{ fontSize: '30px', color: '#008BC3' }} />
								<p>{selectedVideo?.instructor}</p>
							</div>
						)}
					</div>

					<div className="common-tags">
						<VideoTags tags={selectedVideo?.tagsDetails} />
					</div>

					<div className="common-plan">
						<button className="common-plan-button" onClick={() => navigate('/plans')}>
							<div>Upgrade My Account</div>
							<ArrowForwardIcon size={24} />
						</button>
					</div>
				</div>
				<div className="common-video">
					{/* <VideoPlayer
					CustomWrapper={WrapperForVideoPlayer}
					videoLink={selectedVideo?.trailerLink}
					errorMessage={errorMessage}
				/> */}

					<MuxVideoPlayer
						CustomWrapper={WrapperForVideoPlayer}
						videoLink={selectedVideo?.muxTrailerLink}
						poster={selectedVideo?.trailerThumnailLink}
						storyboardToken={selectedVideo?.trailerStoryboardToken}
						errorMessage={errorMessage}
						videoCategory="Trailer"
						videoId={selectedVideo?._id}
						videoTitle={selectedVideo?.title}
					/>
				</div>
			</div>
		</div>
	);
};

const WrapperForVideoPlayer = ({ children }) => {
	return <div className="common-video">{children}</div>;
};

WrapperForVideoPlayer.propTypes = {
	children: PropTypes.node
};

export default ClassVideoTrailer;
